import { generatePath } from 'react-router';

import { Rarity, Sport } from '@sorare/core/src/__generated__/globalTypes';
import {
  ANY_SPORT_MARKET_SCOUT,
  FOOTBALL_MARKET_SCOUT_SO5_COMPETITION_SLUG,
} from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { LIFECYCLE, useLifecycle } from '@sorare/core/src/hooks/useLifecycle';
import { useSo5Competitions } from '@sorare/core/src/hooks/useSo5Competitions';
import { generateSportPath } from '@sorare/core/src/lib/routing/generateSportPath';

export const useMarketHomeFilters = () => {
  const { lifecycle, update } = useLifecycle();
  const { sport } = useSportContext();
  const { scoutableSo5Competitions } = useSo5Competitions();

  const footballRarity = lifecycle?.[LIFECYCLE.newFootballSeasonRarityFilter];
  const filtersBySport = lifecycle?.[LIFECYCLE.marketHomeFilters];
  const filters = filtersBySport?.[sport];

  const marketHomeFilters = (() => {
    return {
      ...filters,
      rarity: filters?.rarity || footballRarity || Rarity.limited,
    };
  })();
  const so5CompetitionSlug = marketHomeFilters?.competitionSlug;

  const { algoliaFilters } = scoutableSo5Competitions.find(
    competition => competition.slug === so5CompetitionSlug
  ) || { algoliaFilters: `sport:${sport.toLowerCase()}` };

  const scoutAllUrl = (() => {
    if (sport === Sport.FOOTBALL) {
      if (so5CompetitionSlug && so5CompetitionSlug !== 'DEFAULT') {
        return generatePath(FOOTBALL_MARKET_SCOUT_SO5_COMPETITION_SLUG, {
          slug: so5CompetitionSlug || '',
        });
      }
    }
    return generateSportPath(ANY_SPORT_MARKET_SCOUT, {
      sport,
    });
  })();

  const updateRarity = (rarity: Rarity) => {
    update(LIFECYCLE.marketHomeFilters, {
      ...filtersBySport,
      [sport]: {
        ...filters,
        rarity,
      },
    });
  };

  return {
    marketHomeFilters,
    update,
    updateRarity,
    algoliaFilters,
    scoutAllUrl,
  };
};
